import React from 'react'
import PropTypes from 'prop-types'

const PATH_D = 'M12.3803 6.1748L8.91641 9.64648L8.56484 10L8.91641 10.3535L12.3803 13.8242L11.9125 '
  + '14.293L7.61953 10L11.9125 5.70703L12.3803 6.1748Z'

const ChevronLeftIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="currentColor"
    height="1em"
    viewBox="0 0 20 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={PATH_D} stroke="currentColor" />
  </svg>
)

ChevronLeftIcon.propTypes = {
  className: PropTypes.string
}

ChevronLeftIcon.defaultProps = {
  className: ''
}

export default ChevronLeftIcon
